<template>
	<div>
		<div class="d-flex align-center justify-end mb-2 mt-2 px-2">
			<div class="d-flex align-center" style="flex: 1;max-width: 400px;">
				<v-icon color="#524D4D" @click="searchForString">mdi-magnify</v-icon>
				<v-text-field
					v-model="searchInput"
					:loading="loadingList"
					outlined
					dense
					hide-details
					item-text="name"
					item-value="id"
					return-object
					clearable
					label="Búsqueda"
					class="mb-0 mr-2 custom-height-search custom-height-calendar"
					color="#524D4D"
					@input="sendToSearch"
				></v-text-field>
			</div>
			<DataTablePagination
				:options.sync="options"
				:item-length="client_requests_count"
				:loading-info="loadingList"
			/>
		</div>
    <v-data-table
			ref="table"
			:headers="headers"
			:items="client_requests"
			item-key="id"
			:loading="loadingList"
			:server-items-length="client_requests_count"
			:options.sync="options"
			loading-text="Cargando datos..."
			class="crm-table"
			:class="$vuetify.breakpoint.mobile ? '':'resizable'"
			disable-sort
			hide-default-footer
			@click:row="selectRow"
			:item-class="selectedRowClass"
			:footer-props="{
        itemsPerPageText: 'Filas por página'
			}"
    >
      <template v-slot:item.project="{ item }">
				<div class="d-flex flex-column" v-if="item.project_line_id">
					<p class="mb-0">{{ getItemProjectName(item) }}</p>
					<p class="mb-0 font-weight-bold">{{ getItemProjectAddress(item) }}</p>
				</div>
				<div class="d-flex flex-column" v-else>
					<p class="mb-0 font-weight-bold">Nuevo Proyecto</p>
					<p class="mb-0">{{ item.project_type?.parent?.name }} - {{ item.project_type?.name }}</p>
				</div>
      </template>
      <template v-slot:item.status="{ item }">
				<div>
					<div class="d-flex align-center">
						<div>
							<v-chip
								:color="getStatusColor( item.status )"
								label
								outlined
								x-small
								class="px-1"
							>
								<b>{{ getStatusText( item.status ) }}</b>
							</v-chip>
						</div>
					</div>
				</div>
      </template>
      <template v-slot:item.actions="{ item }">
				<v-tooltip bottom>
					<template v-slot:activator="{ on, attrs }">
						<v-btn
							icon
							dark
							x-small
							color="#959595"
							class="mx-1"
							@click.stop="() => { selectRow(item); openRequestDetail(item.id); }"

							v-bind="attrs"
							v-on="on"
						>
							<v-icon small dark>mdi-file-document-outline</v-icon>
						</v-btn>
					</template>
					<span>Ver Solicitud</span>
				</v-tooltip>
				<v-tooltip bottom v-if="associatedCrm(item)">
					<template v-slot:activator="{ on, attrs }">
						<v-btn
							icon
							dark
							x-small
							color="#959595"
							class="mx-1"
							@click.stop="() => { selectRow(item); openCrm(associatedCrm(item)); }"
							v-bind="attrs"
							v-on="on"
						>
							<v-icon small dark>mdi-contacts-outline</v-icon>
						</v-btn>
					</template>
					<span>Ver CRM</span>
				</v-tooltip>
      </template>
    </v-data-table>
		<div class="d-flex align-center justify-end mt-2 px-2">
			<DataTablePagination
				:options.sync="options"
				:item-length="client_requests_count"
				:loading-info="loadingList"
			/>
		</div>
	</div>
</template>

<script>
// import moment from 'moment'
import _debounce from 'lodash/debounce'
import {getClientRequests} from '@/helpers/api/clients'
import { eventBus } from '@/components/Helpers/Events/NotificationsEventBus'
import DataTablePagination from '@/components/Helpers/Components/DataTablePagination'

export default {
	name: 'ClientReportList',
	components: {
		DataTablePagination
	},
	props: {
		clientId: {
      type: Number,
      required: true
    },
		openRequestDetail: {
      type: Function,
      required: true
    },
		openCrmDetail: {
      type: Function,
      required: true
    }
	},
	computed: {
		selected_request() {
			return this.$route.query?.ur
		}
	},
	watch: {
    options: {
      handler() {
				this.getClientRequests()
      },
      deep: true,
    }
	},
	data: () => ({
		selectedRowItem: null,
		loadingList: true,
		client_requests: [],
		client_requests_count: 0,
		headers: [
			{ text: '#', value: 'id', align: 'center', width: 100, sortable: false },
			{ text: 'Detalle', value: 'project', align: 'start', sortable: false },
			{ text: 'Estado', value: 'status', align: 'center', width: 160, sortable: false },
			{ text: 'Acciones', value: 'actions', align: 'center', width: 140, sortable: false },
		],
		searchInput: null,
		options: {
			page: 1,
			itemsPerPage: 10,
			sortBy: [],
			sortDesc: [],
		},
	}),
	mounted(){
		this.getClientRequests()
		const request_id = this.$route.query.ur
		if(request_id){
			this.selectedRowItem = request_id
			this.openRequestDetail(request_id)
		}
		else{
			const selectedRow = JSON.parse(localStorage.getItem('selected_clients_requests_row'));
			if (selectedRow) {
				this.selectedRowItem = selectedRow
			}
		}
		eventBus.$on('reloadInformation', this.getClientRequest)
	},
	beforeDestroy(){
		eventBus.$off('reloadInformation', this.getClientRequest);
	},
	methods: {
		selectRow(item){
			this.selectedRowItem = item.id
			localStorage.setItem('selected_clients_requests_row', JSON.stringify(item.id))
		},
		selectedRowClass(item){
			if (this.selectedRowItem && this.selectedRowItem === item.id) {
				return 'selected-row-custom-item';
			}
			return ''
		},
		sendToSearch: _debounce(function() { this.searchForString() }, 800),
		searchForString(){
			this.options = {...this.options, ...{page: 1}}
			this.getClientRequests()
		},
		getClientRequest(){
			this.getClientRequests()
		},
		getRowClass(item) {
			return item.id == this.selected_request ? 'custom-client-highlight-row client-row-report' : 'client-row-report';
		},
		associatedCrm(user_request) {
			if(user_request.status == 2 && user_request.project_line_associations){
				return user_request.project_line_associations.find((item) => {
					return item.morphable_type == 'App\\Models\\BotConversation'
				})
			}
			return null
		},
		openCrm(crm){
			this.openCrmDetail(crm.morphable_id)
		},
		async getClientRequests(){
			this.loadingList = true
			try {
				let data = {
					...this.options,
					client_id: this.clientId,
					start: (this.options.page - 1) * this.options.itemsPerPage,
					limit: this.options.itemsPerPage,
				}
				if(this.searchInput){
					data = {...data, ...{search: this.searchInput}}
				}
				const client_request = await getClientRequests(data)
				if(client_request.code == 200){
					this.client_requests = client_request.user_requests
					this.client_requests_count = client_request.user_requests_count
				}
			} catch (error) {
				console.log(error)
			}
			this.loadingList = false
		},
		getProjectType(items){
			const hierarchy = {
				'App\\Models\\BotConversation': 1,
				'App\\Models\\PreProject': 2,
				'App\\Models\\Project': 3
			};
			const mostRelevant = items.reduce((highest, current) => {
				const currentLevel = hierarchy[current.morphable_type] || 0;
				const highestLevel = highest ? hierarchy[highest.morphable_type] || 0 : 0;

				return currentLevel > highestLevel ? current : highest;
			}, null);
			return mostRelevant;
		},
		getItemProjectName(item){
			const project = this.getProjectType(item.project_line_associations)
			return project?.morphable?.name || item.project_name || '--'
		},
		getItemProjectAddress(item){
			const project = this.getProjectType(item.project_line_associations)
			return project?.morphable?.info?.address?.address || item.address?.address || '--'
		},
		getUserName(request){
			let name = ''
			const item = request.user
			if(item.profile){
				name = item.profile.name + ' ' + item.profile.lastname + ' ' + item.profile.second_lastname
			}
			return name
		},
		getStatusColor(status){
			if(status === 1){
				return '#524D4D'
			}
			else if(status === 2){
				return 'green'
			}
			else if(status === 3){
				return 'red'
			}
		},
		getStatusText(status){
			if(status === 1){
				return 'Creado'
			}
			else if(status === 2){
				return 'Aceptado'
			}
			else if(status === 3){
				return 'Rechazado'
			}
		},
    setMessage(messageData){
      const data = {
        message: messageData.message,
        title: messageData.title,
        created: new Date(),
        type: messageData.type,
        icon: messageData.icon,
        color: messageData.color,
      }
      this.$store.dispatch('general/addMessage', data)
    },
	}
}
</script>

<style>
.custom-client-highlight-row {
  background-color: #e8e8e8 !important;
}
.client-row-report{
	cursor: pointer;
}
</style>